import { formSectionType } from "./constants";

function useQuestionFields({
  eachField = {},
  tableRowId = "",
  extraParams = {},
  section = {},
  tableRowIndex = 0,
  source = "",
  formData = {},
  userId = "",
  disabled = false,
  showAnswersOnly = false,
  getPermissions,
}) {
  const questionId = eachField._id ?? "";

  let name = tableRowId ? `${tableRowId}${questionId}` : questionId;
  if (extraParams.id) {
    name = `${extraParams.id}_${name}`;
  }

  const sectionId = section._id ?? "";

  const { permissions, tableDataSource = [] } = section;

  let currentAnswer = eachField.answer ?? {};
  if (source === formSectionType.TABLE_SECTION) {
    currentAnswer = tableDataSource[tableRowIndex]?.[questionId] ?? {};
  }

  const isCurrentUserAllowedToFill = permissions
    ? getPermissions({ inspectionData: formData, permissions, type: "Fill", userId })
    : !disabled;

  const isCurrentUserAllowedToModify = permissions
    ? getPermissions({ inspectionData: formData, permissions, type: "Modify", userId })
    : !disabled;

  const enabled = (isCurrentUserAllowedToFill || isCurrentUserAllowedToModify) && !showAnswersOnly;

  return {
    questionId,
    name,
    sectionId,
    currentAnswer,
    isCurrentUserAllowedToFill,
    isCurrentUserAllowedToModify,
    enabled,
    permissions,
  };
}

export default useQuestionFields;
